import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { getResolucion, newRegistromto } from '../../../redux/actions';
import styles from './Cerrarticket.module.css';
import { format } from 'date-fns';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const Cerrarticketmto = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { ticketId } = location.state || {};

    const [value, setValue] = useState(0);
    const [observacionesSatis, setObservacionesSatis] = useState('');

    const resolucion = useSelector((state) => state.resolucion);

    // console.log("SOLUCION::",resolucion)

    const [formData, setFormData] = useState({
        observaciones_gen: '',
        actividades: [],
        mediciones: '',
        repuesto: '',
        otro_repuesto: '',
        personas: 0
    });

    useEffect(() => {
        if (ticketId) {
            dispatch(getResolucion(ticketId));
        }
    }, [dispatch, ticketId]);

    useEffect(() => {
        if (resolucion && resolucion.data) {
            const { resolucionDetails } = resolucion.data;

            // Reconstruir actividades realizadas
            const acts = [];
            if (resolucionDetails.revgenfuncion) acts.push("Revisión general funcionamiento");
            if (resolucionDetails.limpgeneral) acts.push("Limpieza general");
            if (resolucionDetails.revtemperatura) acts.push("Revision temperatura");
            if (resolucionDetails.revsisseguridad) acts.push("Revisión del sistema de seguridad");
            if (resolucionDetails.revsisenfriamiento) acts.push("Revisión del sistema de enfriamiento");
            if (resolucionDetails.lubricacion) acts.push("Lubricación");
            if (resolucionDetails.otra_actividad) acts.push(`Otra: ${resolucionDetails.otra_actividad}`);

            setFormData({
                observaciones_gen: resolucionDetails.observaciones_gen || '',
                actividades: acts,
                mediciones: resolucionDetails.revvoltaje || '',
                repuesto: resolucionDetails.repuesto || '',
                otro_repuesto: resolucionDetails.otro_repuesto || '',
                personas: resolucionDetails.num_personas || 0
            });
        }
    }, [resolucion]);

    const handleBack = () => {
        navigate('/seguimiento-ticket');
    };

    const handleSatisfaccionChange = (newValue) => {
        setValue(newValue);
    };

    const handleCerrar = (e) => {
        e.preventDefault();

        if (value === 0 || !observacionesSatis.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe calificar el servicio e ingresar el motivo de su calificación.'
            });
            return;
        }

        const data = {
            fecha: new Date().toISOString(),
            Observacion: observacionesSatis,
            TicketId: ticketId,
            EstadoId: 5, // Estado Cerrado
            UsuarioId: resolucion.data.ticketDetails.UsuarioId,
            votacion: value,
            tecnico: resolucion.data.ticketDetails.usuarioDetails.nombre,
            flag: 2 // Identificar como mantenimiento al cerrar
        };

        dispatch(newRegistromto(data))
            .then(() => {
                MySwal.fire({
                    title: 'Ticket Cerrado',
                    text: 'Se ha cerrado exitosamente su ticket de mantenimiento.',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                }).then(() => {
                    navigate('/seguimiento-ticket');
                });
            })
            .catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un problema al cerrar el ticket.'
                });
            });
    };

    if (!resolucion || !resolucion.data) {
        return <p>Cargando información del ticket...</p>;
    }

    const { ticketDetails } = resolucion.data;

    return (
        <div className={styles.container}>
            <FaArrowLeft className={styles.backIcon} onClick={handleBack} />
            <h2>Cierre de Ticket - Área Mantenimiento</h2>

            <fieldset className={styles.fieldset}>
                <legend>Información General: <strong>{ticketId}</strong></legend>
                <div className={styles.infoRow}>
                    <span><strong>Fecha Solución:</strong> {format(new Date(ticketDetails.fecha), 'yyyy-MM-dd HH:mm:ss')}</span>
                    <span><strong>Técnico:</strong> {ticketDetails.usuarioDetails.nombre}</span>
                </div>
            </fieldset>

            <fieldset className={styles.fieldset}>
                <legend>Resumen de Actividades</legend>
                <div className={styles.checkboxGroup}>
                    {formData.actividades.length > 0 ? (
                        formData.actividades.map((act, idx) => (
                            <label key={idx}>✅ {act}</label>
                        ))
                    ) : (
                        <p>No se registraron actividades específicas.</p>
                    )}
                </div>
            </fieldset>

            <div className={styles.columns}>
                <fieldset className={styles.fieldset}>
                    <legend>Mediciones y Repuestos</legend>
                    <p><strong>Voltaje/Mediciones:</strong> {formData.mediciones || 'N/A'}</p>
                    <p><strong>Repuesto:</strong> {formData.repuesto} {formData.otro_repuesto ? `(${formData.otro_repuesto})` : ''}</p>
                    <p><strong>Personal en compañía:</strong> {formData.personas}</p>
                </fieldset>

                <fieldset className={styles.fieldset}>
                    <legend>Observaciones Técnicas</legend>
                    <p>{formData.observaciones_gen || 'Sin observaciones adicionales.'}</p>
                </fieldset>
            </div>

            <div className={styles.satisfactionSection}>
                <label><strong>Satisfacción del servicio:</strong></label>
                <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                    {[1, 2, 3, 4, 5].map((num) => (
                        <span
                            key={num}
                            className={styles.emoji}
                            style={{ opacity: value === num ? 1 : 0.3, transform: value === num ? 'scale(1.2)' : 'scale(1)' }}
                            onClick={() => handleSatisfaccionChange(num)}
                        >
                            {num === 1 ? '😢' : num === 2 ? '😞' : num === 3 ? '😕' : num === 4 ? '😊' : '😄'}
                        </span>
                    ))}
                </div>

                {value > 0 && (
                    <div style={{ marginTop: '20px' }}>
                        <p><strong>Calificación: {value}</strong></p>
                        <textarea
                            value={observacionesSatis}
                            onChange={(e) => setObservacionesSatis(e.target.value)}
                            placeholder="Ingrese el motivo de su calificación..."
                            className={styles.textareasatis}
                            required
                        />
                    </div>
                )}
            </div>

            <button
                onClick={handleCerrar}
                className={styles.button}
                style={{ marginTop: '30px' }}
            >
                Finalizar y calificar servicio
            </button>
        </div>
    );
};

export default Cerrarticketmto;
